<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      hide-footer
      hide-header
      title="Using Component Methods"
    >
      <a
        class="btn-close"
        @click="hideModal"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <div class="d-block text-center">
        <img
          :src="require('@/assets/images/alert.png')"
          alt="Success"
          class="img-success-register"
        >
      </div>
      <div class="modal-text">
        <h4>
          Disabled this account?
        </h4>
        <div class="d-flex justify-content-center container-button mt-2">
          <div />
          <div>
            <b-button
              variant="outline-secondary"
              class="ml-1"
              @click="hideModal"
            >
              <span class="align-middle">Cancel</span>
              <feather-icon
                icon="XCircleIcon"
                class="ml-50"
              />
            </b-button>
            <b-button
              variant="primary"
              class="ml-1"
              @click="actionDisabled"
            >
              <span class="align-middle">Disabled</span>
              <feather-icon
                icon="CheckCircleIcon"
                class="ml-50"
              />
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BModal,
    BButton,
  },
  props: {

  },
  methods: {
    ...mapActions('account', [
      'approveClient',
    ]),
    actionDisabled() {
      this.approveClient().then(() => {
        this.hideModal()
        this.success()
      }, error => {
        console.error('err', error)
      })
    },
    success() {
      this.$swal({
        title: 'Disabled!',
        text: 'Partner now disabled',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          const routeName = this.$route.matched[0].path
          this.$router.push({ path: `${routeName}/partner` })
        }
      })
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
  },
}
</script>
<style scoped>
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.img-success-register {
  margin-top: 43px;
}
.modal-text {
  text-align: center;
  font-family: 'Rubik';
  margin-top: 18px;
  margin-bottom: 40px
}

.modal-text > h4 {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}

.modal-text > p {
  margin-top: 15px;
}
</style>
